var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-link",attrs:{"to":_vm.route.path}},[_c('v-list-item',{attrs:{"link":""}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.route.meta.title)+" ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }